<template>
  <div class="block" v-if="items.length > 0">
    <p class="block-title" :class="tone">{{ title }}: {{ items.length }}</p>
    <div class="report-list">
      <div v-for="(item, index) in items" :key="`${item}_${index}`" class="report-item">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkServicesReportBlock',
  props: {
    title: { required: true, type: String },
    items: { required: true, type: Array },
    tone: { default: '', type: String }
  }
}
</script>

<style scoped>
  .block {
    margin-top: 8px;
    padding: 6px 10px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
  }
  .block-title {
    margin-bottom: 4px;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--secondary-text-color);
  }
  .block-title.ok { color: #28a745; }
  .block-title.error { color: #dc3545; }
  .block-title.warn { color: #b8860b; }
  .report-list {
    max-height: 150px;
    overflow-y: auto;
  }
  .report-item {
    font-family: monospace;
    font-size: 0.75rem;
    line-height: 1.5;
    color: var(--primary-text-color);
  }
</style>
